import * as React from "react";
import { useTopicList } from "./hooks.js";
import TopicList from "./TopicList.js";
const TopicListContainer = (props) => {
  const topicList = useTopicList();
  return /* @__PURE__ */ React.createElement(TopicList, { ...props, options: topicList });
};
export {
  TopicListContainer as default
};
//# sourceMappingURL=TopicListContainer.js.map
